import Skeleton from '@mui/material/Skeleton';
import { SxProps, Theme } from '@mui/material/styles';

interface Props {
  isLoading: boolean;
  children?: React.ReactNode;
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'rectangular' | 'circular';
  animation?: 'pulse' | false | 'wave';
  style?: React.CSSProperties;
  component?: React.ElementType<any>;
  scaleOneToOne?: boolean;
  sx?: SxProps<Theme> | undefined;
}

/*
https://material-ui.com/api/skeleton/
The LoadingSkeleton component should be placed around individual "sections" like fields, buttons, pictures instead of groups of the above. 
Also the LoadingSkeleton sometimes has difficulty inferring the height of deeply nested components so its better to be more specific (wrap exact component(s)) when using it
*/
const LoadingSkeleton = ({
  isLoading,
  children,
  variant = 'text',
  animation = 'wave',
  width = '100%',
  height = undefined,
  style = undefined,
  component = 'div',
  scaleOneToOne = false,
  sx,
}: Props) => {
  const transformStyle = scaleOneToOne ? { transform: 'scale(1,1)' } : {};

  return isLoading ? (
    <Skeleton
      variant={variant}
      animation={animation}
      width={width}
      height={height}
      /** The skeleton does not reach the specified height due to font scaling which sets it to 0.6 */
      style={{ ...style, ...transformStyle }}
      component={component}
      sx={sx}
    >
      {children}
    </Skeleton>
  ) : (
    <>{children}</>
  );
};

export default LoadingSkeleton;
